import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { MY_TEAM_URL_FRAGMENT, MY_TEAM_CERTIFICATIONS_URL_FRAGMENT, MY_TEAM_MEMBERS_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
const BREADCRUMB_CONFIG = {
  MY_TEAM: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_TEAM_OVERVIEW"
    }),
    path: MY_TEAM_URL_FRAGMENT
  },
  MY_TEAM_CERTIFICATIONS: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS"
    }),
    path: MY_TEAM_CERTIFICATIONS_URL_FRAGMENT
  },
  MY_TEAM_MEMBERS: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_TEAM_MEMBERS"
    }),
    path: MY_TEAM_MEMBERS_URL_FRAGMENT
  },
  MY_TEAM_PLAYLISTS: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_TEAM_PLAYLISTS"
    }),
    path: `${MY_TEAM_URL_FRAGMENT}/playlists`
  },
  MY_TEAM_CERTIFICATIONS_BY_TEAM: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
    }),
    path: `${MY_TEAM_URL_FRAGMENT}/certifications-by-team`
  }
};
export const getBreadcrumbItem = ({
  pageKey,
  isCurrent = false
}) => {
  const config = BREADCRUMB_CONFIG[pageKey];
  if (!config) {
    Raven.captureException(new Error(`No breadcrumb config for page: ${pageKey}`));
  }
  return {
    label: config.label,
    to: isCurrent ? undefined : config.path
  };
};